import type { AdresFieldPaths } from './types';

export function getAdresFieldPaths(prefix = 'adres'): AdresFieldPaths {
  const dotPrefix = prefix ? `${prefix}.` : '';
  const adresFields = [
    'huisnummer',
    'huisnummertoevoeging',
    'plaats',
    'postcode',
    'straat',
  ] as const;

  return adresFields.reduce(
    (previousValue, currentValue) => ({
      ...previousValue,
      [currentValue]: `${dotPrefix}${currentValue}`,
    }),
    {} as AdresFieldPaths,
  );
}
